import * as PropTypes from 'prop-types';
import React from 'react';

export class DropdownListItem extends React.Component<any, any> {
  static propTypes = {
    value: PropTypes.any,
    title: PropTypes.node,
    description: PropTypes.node,
    onClick: PropTypes.func,
    selected: PropTypes.bool
  };

  onClick = e => {
    e.preventDefault();
    if (this.props.onClick) {
      this.props.onClick(this.props.value);
    }
  };

  render() {
    return (
      <li onClick={this.onClick}>
        <a className={this.props.selected && 'is-selected'}>
          {this.props.description ? (
            <span>
              <strong>{this.props.title}</strong>
              <small>{this.props.description}</small>
            </span>
          ) : (
            this.props.title
          )}
          {this.props.tag && <span className="ui-dropdown__tag">{this.props.tag}</span>}
        </a>
      </li>
    );
  }
}
